import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import CancelIcon from '@material-ui/icons/Cancel';
import {Styles} from './Styles';

interface Props {
    close():void,
}

const ModalHead:React.FC<Props> = (props)=> {
	const classes = Styles.base();
	return (
		<div id="modal_head" className={classes.modalHead}>
            <IconButton aria-label="close" onClick={props.close} style={{marginBottom:"0.2em",marginLeft:"0.2em",padding:"0"}}>
			    <CancelIcon style={{color:"white"}}/>
            </IconButton>
		</div>
    );
}

export default ModalHead;
